function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/********************************************************************************
 * Copyright (C) 2021 Ant Group and others.
 *
 * Date 2021-05-31 14:58:29.
 * Have a nice day.
 ********************************************************************************/

/* eslint-disable @typescript-eslint/no-explicit-any */

import { Emitter } from "./event";
import { Disposable } from "./disposable";
export var DisposableCollection = /*#__PURE__*/function () {
  function DisposableCollection() {
    var _this = this;
    _classCallCheck(this, DisposableCollection);
    _defineProperty(this, "disposables", []);
    _defineProperty(this, "onDisposeEmitter", new Emitter());
    _defineProperty(this, "disposingElements", false);
    for (var _len = arguments.length, toDispose = new Array(_len), _key = 0; _key < _len; _key++) {
      toDispose[_key] = arguments[_key];
    }
    toDispose.forEach(function (d) {
      return _this.push(d);
    });
  }

  /**
   * This event is fired only once
   * on first dispose of not empty collection.
   */
  _createClass(DisposableCollection, [{
    key: "onDispose",
    get: function get() {
      return this.onDisposeEmitter.event;
    }
  }, {
    key: "checkDisposed",
    value: function checkDisposed() {
      if (this.disposed && !this.disposingElements) {
        this.onDisposeEmitter.fire(undefined);
        this.onDisposeEmitter.dispose();
      }
    }
  }, {
    key: "disposed",
    get: function get() {
      return this.disposables.length === 0;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this.disposed || this.disposingElements) {
        return;
      }
      this.disposingElements = true;
      while (!this.disposed) {
        try {
          this.disposables.pop().dispose();
        } catch (e) {
          console.error(e);
        }
      }
      this.disposingElements = false;
      this.checkDisposed();
    }
  }, {
    key: "push",
    value: function push(disposable) {
      var _this2 = this;
      var disposables = this.disposables;
      disposables.push(disposable);
      var originalDispose = disposable.dispose.bind(disposable);
      var toRemove = Disposable.create(function () {
        var index = disposables.indexOf(disposable);
        if (index !== -1) {
          disposables.splice(index, 1);
        }
        _this2.checkDisposed();
      });
      disposable.dispose = function () {
        toRemove.dispose();
        originalDispose();
      };
      return toRemove;
    }
  }, {
    key: "pushAll",
    value: function pushAll(disposables) {
      var _this3 = this;
      return disposables.map(function (disposable) {
        return _this3.push(disposable);
      });
    }
  }]);
  return DisposableCollection;
}();